<template>
  <ModalDialog
    ref="dialog"
    title="Send Order"
    :submitting="submitting"
    :scrollable="true"
    :submitDisabled="currentlyUploading"
    submitTitle="Send Order"
    icon="fa-envelope-open-text"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <EmailMessageForm 
        :contactId="contactId"
        :defaultContactPersonId="defaultContactPersonId"
        :defaultCCList="defaultCCList"
        :templateType="MessageTemplateTypes.order"
        :messageTemplateUpdateFn="messageTemplateUpdateFn"
        :previewLink="previewLink"
        :showOptions="true"
        :requireContactPerson="false"
        @uploading="currentlyUploading = $event"
        @update="emailDetails = $event">
        <template v-slot:options>
          <FormRow label="Show Pricing">
            <FormSwitch booleanMode v-model="options.showPricing" />
          </FormRow>
        </template>
      </EmailMessageForm>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { ApprovalTypes, MessageTemplateTypes } from '@/store/types'

export default {
  name: 'SendOrderDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    contactId: Number,
    defaultContactPersonId: Number,
    customContactEmail: String,
    orderId: Number,
  },
  data() {
    return {
      dialogForm: {},
      emailDetails: { },
      options: {
        showPricing: true
      },
      submitting: false,
      currentlyUploading: false,

      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    previewLink() {
      var params = {
        hideprices: !this.options.showPricing
      }
      var previewParams = $.param(params)

      return `/orders/${this.orderId}/report?${previewParams}`
    },
    defaultCCList() {
      if(!this.defaultContactPersonId && this.customContactEmail && this.customContactEmail != '')
        return [this.customContactEmail]
      return []
    }
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var orderEmailData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        emailPersonList: this.emailDetails.contactPersonList.map(person => { return {contactPersonId: person.id } }),
        uploadFileList: this.emailDetails.uploadFileList,
        hidePrices: !this.options.showPricing,
        ccList: this.emailDetails.ccList
      }

      this.$apiService.ordersService.sendOrderEmail(this.orderId, orderEmailData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.ordersService.getOrderSendOrderTemplate(this.orderId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>